<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">{{$t('login.login')}}</h3>
      </div>
       <el-form-item class="select_box">
        <span class="svg-container">
          <i class="el-icon-info"></i>
        </span>
        <el-select   @change="choiceLang" :placeholder="$t('login.choiceLang')" v-model="loginForm.language">
          <el-option
            v-for="item in langArr"
            :key="item.label"
            :label="item.name"
            :value="item.label"

          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          ref="username"
          v-model="loginForm.username"
          :placeholder="$t('user.loginName')"
          name="username"
          type="text"
          tabindex="1"
          auto-complete="on"
        />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :key="passwordType"
          ref="password"
          v-model="loginForm.password"
          :type="passwordType"
          :placeholder="$t('login.password')"
          name="password"
          tabindex="2"
          auto-complete="on"
          @keyup.enter.native="handleLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>

      <el-button
        :loading="loading"
        type="primary"
        style="width:100%;margin-bottom:30px;"
        @click.native.prevent="handleLogin"
      >{{$t('login.login')}}</el-button>

    </el-form>
  </div>
</template>

<script>
import { localSave, localRemove, localRead} from '@/utils/tools'
import imStore from '@/store/modules/im'
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        model: "",
        language:''
      },
      projectArr: [], //可选择的项目集合
      projectArrAll: [], //所有项目集合
      langArr:[
        {label:'en_US',name:"English"},
        {label:'zh_CN',name:"简体中文"},
        {label:'vi_VN',name:"Tiếng Việt"}
      ],
      loading: false,
      passwordType: "password",
      redirect: undefined
    };
  },
  computed: {
    webSocket: {
      get() {
        return this.$store.state.im.webSockets
      }
    },
  },
  methods: {
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() { this.loading = true;
          this.$store
            .dispatch("user/login", this.loginForm)
            .then(() => {
              if(!localRead("language")){
                localSave("language",'zh_CN')
              }
              this.$router.push({ path:  "/" });

              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
    },
    getProjectInfo(){
        for (let i in this.projectArr) {
            if (this.projectArr[i].id == this.loginForm.model) return this.projectArr[i];
        }
        return {};
    },
    choiceLang(val){
      this.$i18n.locale = val
      localSave("language",val)
    }
  },
  mounted() {
    if (this.webSocket.url) this.webSocket.close();
    localRemove('sys_userInfo_IM')
    localRemove('locale_IM')
    localRemove('IM_tabViews')
  }
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" >
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .select_box {
    .el-form-item__content{
      display: flex;
    }
    .el-input{
      width:100%;
    }
    .el-select{
      float: right;
      width: 100%;
    }
  }
}
</style>
